module.exports = __webpack_public_path__ + "img/konfetti.789a4e7d.svg";